import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import axios from 'axios'

export interface MaintenanceResult {
  endAt?: Date
  maintenanceMode?: boolean
  message?: string
  messageResolved?: string
  startAt?: Date
}

export const getMaintenanceData = async (): Promise<MaintenanceResult> => {
  const loginUrl = sfOauthConfig.oauth2?.loginUrl
  if (typeof loginUrl !== 'string' || loginUrl.length === 0) {
    return await Promise.reject(new Error('Missing Salesforce login URL'))
  }
  const baseUrl = loginUrl.endsWith('/') ? loginUrl.slice(0, -1) : loginUrl
  return await axios.get(`${baseUrl}/services/apexrest/portal/config`).then(result => result.data)
}
